module.exports = __webpack_public_path__ + "img/biter-attack-mask2.0aeddabb.png";